const slugify = require("slugify");

const slugRegex = /[*+~%<>/;.(){}?,'"!:@#^|]/g;
exports.slugRegex = slugRegex;

exports.slugifyWithRegex = text => {
  return slugify(text, {
    lower: true,
    remove: slugRegex,
  });
};

exports.calculateSimilarity = (queryList, probList) => {
  let a = new Set(queryList);
  let b = new Set(probList);

  let intersection = [...a].filter(i => b.has(i)).length;
  let union = a.size + b.size - intersection;

  return intersection / union;
};

exports.cleanBookNames = bookTitle => {
  return bookTitle;
};

exports.copyToClipboard = copyText => {
  if (typeof navigator !== "undefined") {
    navigator.permissions.query({ name: "clipboard-write" }).then(result => {
      if (result.state === "granted" || result.state === "prompt") {
        navigator.clipboard.writeText(copyText).then(() => {
          // Alert the user that the action took place.
          // Nobody likes hidden stuff being done under the hood!
          console.log("Copied to clipboard");
        });
      }
    });
  }
};

exports.sliceToNextSpace = (text, seaerchIndex, searchTerm = " ") => {
  return text.slice(0, text.indexOf(searchTerm, seaerchIndex));
};
